import AppAdapter from 'adapters/app';

class IntervalAdapter extends AppAdapter {
  constructor(props) {
    super(props)
  }

	static userId = '';
	static providerId = '';
}

export default IntervalAdapter;